//Market Review---Mrv
//Market Preview---Prv
//Market Guide--- MG
//Market review & Preview ---MRP
export var oktaAuthConfigMrv = {
    issuer: import.meta.env.VITE_OKTA_ISSUER_MRP,
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID_Mrv,
    redirectUri: import.meta.env.VITE_PUBLIC_URL_Mrv,
    scopes: ['basic emailFactSheet'],
    state: encodeURI(Date.now() + "" + Math.random()),
    pkce: true,
    tokenManager: { secure: true, storage: "cookie" }
};
export var oktaAuthConfigPrv = {
    issuer: import.meta.env.VITE_OKTA_ISSUER_MRP,
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID_Prv,
    redirectUri: import.meta.env.VITE_PUBLIC_URL_Prv,
    scopes: ['basic emailFactSheet clientColleague'],
    state: encodeURI(Date.now() + "" + Math.random()),
    pkce: true,
    tokenManager: { secure: true, storage: "cookie" }
};
export var oktaAuthConfigMg = {
    issuer: import.meta.env.VITE_OKTA_ISSUER_MG,
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID_MG,
    redirectUri: import.meta.env.VITE_PUBLIC_URL_MG,
    scopes: ['basic emailFactSheet'],
    state: encodeURI(Date.now() + "" + Math.random()),
    pkce: true,
    tokenManager: { secure: true, storage: "cookie" }
};
